<ul>
  @switch (role?.name) {
    @case (roleType.DEVELOPER) {
      <ng-container *ngTemplateOutlet="DeveloperLearningPath"></ng-container>
      <ng-container *ngTemplateOutlet="SystemAdminstratorLearningPath"></ng-container>
    }
    @case (roleType.ADMINISTRATOR) {
      <ng-container *ngTemplateOutlet="SystemAdminstratorLearningPath"></ng-container>
    }
    @case (roleType.ADMIN) {
      <ng-container *ngTemplateOutlet="SystemAdminstratorLearningPath"></ng-container>
    }
    @case (roleType.ARCHITECT) {
      <ng-container *ngTemplateOutlet="DeveloperLearningPath"></ng-container>
      <ng-container *ngTemplateOutlet="SystemAdminstratorLearningPath"></ng-container>
    }
    @case (roleType.SYSTEM_ADMINISTRATOR) {
      <ng-container *ngTemplateOutlet="DeveloperLearningPath"></ng-container>
      <ng-container *ngTemplateOutlet="SystemAdminstratorLearningPath"></ng-container>
    }
    @case (roleType.GENESYS_CLOUD_VOICE_ADMIN) {
      <ng-container *ngTemplateOutlet="SystemAdminstratorLearningPath"></ng-container>
    }
    @case (roleType.TELEPHONY_ADMIN) {
      <ng-container *ngTemplateOutlet="SystemAdminstratorLearningPath"></ng-container>
    }
    @case (roleType.COMMUNICATE_ADMIN) {
      <ng-container *ngTemplateOutlet="SystemAdminstratorLearningPath"></ng-container>
    }
    @case (roleType.OUTBOUND_ADMIN) {
      <ng-container *ngTemplateOutlet="SystemAdminstratorLearningPath"></ng-container>
    }
    @case (roleType.WEM_QUALITY_ADMIN) {
      <ng-container *ngTemplateOutlet="WEMLearningPath"></ng-container>
    }
    @case (roleType.WEM_QUALITY_ADMINISTRATOR) {
      <ng-container *ngTemplateOutlet="WEMLearningPath"></ng-container>
    }
    @case (roleType.WEM_PERFORMANCE_MANAGEMENT_ADMIN) {
      <ng-container *ngTemplateOutlet="WEMLearningPath"></ng-container>
    }
    @case (roleType.WEM_PLANNER_ADMIN) {
      <ng-container *ngTemplateOutlet="WEMLearningPath"></ng-container>
    }
    @case (roleType.WEM_PLANNING_ADMIN) {
      <ng-container *ngTemplateOutlet="WEMLearningPath"></ng-container>
    }
    @case (roleType.SUPERVISOR) {
      <ng-container *ngTemplateOutlet="WEMLearningPath"></ng-container>
    }
    @default {
      <ng-container *ngTemplateOutlet="NoRolesLearningPath"></ng-container>
    }
  }
</ul>

<!--No Roles or Custom Role that is not defined-->
<ng-template #NoRolesLearningPath>
  <li>
    <a
      class="overlay-link"
      (click)="onLinkClick()"
      href="https://beyond.genesys.com/explore/learning-path/home"
      target="_blank"
      title="Learning Path"
      >Learning Paths</a
    >
  </li>
</ng-template>

<!--Developer Learning Path-->
<ng-template #DeveloperLearningPath>
  <li>
    <a
      class="overlay-link"
      (click)="onLinkClick()"
      href="https://beyond.genesys.com/explore/learning-path/lp-developer"
      target="_blank"
      title="Developer Learning Path"
      >Developer Learning Path</a
    >
  </li>
</ng-template>

<!--WEM Learning Path-->
<ng-template #WEMLearningPath>
  <ng-container *ngTemplateOutlet="SystemAdminstratorLearningPath"></ng-container>
  <ng-container *ngTemplateOutlet="AgentPlatformSupervisorLearningPath"></ng-container>
</ng-template>

<!--System Administrator Learning Path-->
<ng-template #SystemAdminstratorLearningPath>
  <li>
    <a
      class="overlay-link"
      (click)="onLinkClick()"
      href="https://beyond.genesys.com/explore/learning-path/lp-system-administrator"
      target="_blank"
      title="System Administrator Learning Path"
      >System Administrator Learning Path</a
    >
  </li>
</ng-template>

<!--Agent Supervisor Learning Path-->
<ng-template #AgentPlatformSupervisorLearningPath>
  <li>
    <a
      class="overlay-link"
      (click)="onLinkClick()"
      href="https://beyond.genesys.com/explore/learning-path/lp-agent-supervisor"
      >Agent Supervisor Learning Path</a
    >
  </li>
</ng-template>
